import {CommentsCategory, type CommentDto, useComments} from '@domain/comments'
import {useUpmPlantContext} from '@hconnect/upm'
import {useCallback} from 'react'

interface UseScheduleCommentsQueryOptions {
  scheduleItemIds: string[]
  selectedScheduleItemIds: string[]
  isDisabled?: boolean
}

export const useScheduleCommentsQuery = ({
  scheduleItemIds,
  selectedScheduleItemIds,
  isDisabled = false
}: UseScheduleCommentsQueryOptions) => {
  const {plantId} = useUpmPlantContext()

  const selectComments = useCallback(
    (comments: CommentDto[]) =>
      comments.filter((comment) =>
        selectedScheduleItemIds.includes(comment.commentsCategoryInstanceId)
      ),
    [selectedScheduleItemIds]
  )

  return useComments(
    {
      plantId,
      commentsCategory: CommentsCategory.AssetOperationTimes,
      commentCategoryInstanceIds: scheduleItemIds
    },
    'comments',
    {
      enabled: scheduleItemIds.length > 0 && !isDisabled,
      select: selectComments
    }
  )
}
